import React from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";

import { useStyles } from "./Styles";

const propTypes = {
  children: PropTypes.object.isRequired,
  style: PropTypes.object.isRequired,
};

ItemRow.prototype = propTypes;

export default function ItemRow(props) {
  return (
    <Grid item xs={12} md={6} className={props.style}>
      {props.children}
    </Grid>
  );
}
